import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';

export const CategoryEmpty = styled.div`
  margin-top: 60px;
`;

export const Text = styled.p`
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_5,
    styles.fontWeights.NORMAL
  )};
  line-height: 26px;
  margin-bottom: 0;
  text-align: center;

  &:first-of-type {
    margin-bottom: 5px;
  }
`;

export const GuideText = styled.p`
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_6,
    styles.fontWeights.NORMAL
  )};
  line-height: 31px;
  margin: 57px 0 0;
  text-align: center;

  > a {
    color: #8d8d8d;
    text-decoration: underline;
  }
`;

export const Title = styled.h2`
  ${mixins.fontStyle(
    styles.colors.MAIN_COLOR,
    styles.fontSizes.SIZE_1,
    styles.fontWeights.SEMIBOLD
  )};
  line-height: 47px;
  margin: 0 0 3px;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/screens/Product/CategoryEmpty/style.js